/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MilestoneCreateRequest,
  MilestoneDto,
  MilestoneUpdateRequest,
  POAMCreateRequest,
  POAMDto,
  POAMItemCreateRequest,
  POAMItemDto,
  POAMItemUpdateRequest,
  POAMListResponse,
  POAMUpdateRequest,
} from '../models/index';
import {
    MilestoneCreateRequestFromJSON,
    MilestoneCreateRequestToJSON,
    MilestoneDtoFromJSON,
    MilestoneDtoToJSON,
    MilestoneUpdateRequestFromJSON,
    MilestoneUpdateRequestToJSON,
    POAMCreateRequestFromJSON,
    POAMCreateRequestToJSON,
    POAMDtoFromJSON,
    POAMDtoToJSON,
    POAMItemCreateRequestFromJSON,
    POAMItemCreateRequestToJSON,
    POAMItemDtoFromJSON,
    POAMItemDtoToJSON,
    POAMItemUpdateRequestFromJSON,
    POAMItemUpdateRequestToJSON,
    POAMListResponseFromJSON,
    POAMListResponseToJSON,
    POAMUpdateRequestFromJSON,
    POAMUpdateRequestToJSON,
} from '../models/index';

export interface AddMilestoneRequest {
    poamId: string;
    itemId: string;
    milestoneCreateRequest: MilestoneCreateRequest;
}

export interface AddPOAMItemRequest {
    poamId: string;
    pOAMItemCreateRequest: POAMItemCreateRequest;
}

export interface CreatePOAMFromFindingRequest {
    pOAMCreateRequest: POAMCreateRequest;
}

export interface DeleteMilestoneRequest {
    poamId: string;
    itemId: string;
    milestoneId: string;
}

export interface GetMilestonesForItemRequest {
    poamId: string;
    itemId: string;
}

export interface GetPOAMByIdRequest {
    poamId: string;
}

export interface GetPOAMsRequest {
    status?: string;
    page?: string;
    pageSize?: string;
}

export interface UpdateMilestoneRequest {
    poamId: string;
    itemId: string;
    milestoneId: string;
    milestoneUpdateRequest: MilestoneUpdateRequest;
}

export interface UpdatePOAMRequest {
    poamId: string;
    pOAMUpdateRequest: POAMUpdateRequest;
}

export interface UpdatePOAMItemRequest {
    poamId: string;
    itemId: string;
    pOAMItemUpdateRequest: POAMItemUpdateRequest;
}

/**
 * POAMApi - interface
 * 
 * @export
 * @interface POAMApiInterface
 */
export interface POAMApiInterface {
    /**
     * Creates a new milestone for the given POAM item. Title is required.
     * @summary Add milestone to POAM item
     * @param {string} poamId POAM UUID
     * @param {string} itemId POAM item UUID
     * @param {MilestoneCreateRequest} milestoneCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    addMilestoneRaw(requestParameters: AddMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MilestoneDto>>;

    /**
     * Creates a new milestone for the given POAM item. Title is required.
     * Add milestone to POAM item
     */
    addMilestone(requestParameters: AddMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MilestoneDto>;

    /**
     * Adds a new POAM item (project item) to an existing POAM. Title and description are required. Optional findingId links the item to a finding and control.
     * @summary Add POAM item
     * @param {string} poamId POAM UUID
     * @param {POAMItemCreateRequest} pOAMItemCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    addPOAMItemRaw(requestParameters: AddPOAMItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMItemDto>>;

    /**
     * Adds a new POAM item (project item) to an existing POAM. Title and description are required. Optional findingId links the item to a finding and control.
     * Add POAM item
     */
    addPOAMItem(requestParameters: AddPOAMItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMItemDto>;

    /**
     * Creates a new Plan of Action and Milestones (POAM) linked to a finding. The POAM will contain a POAM item that references the finding. Optional budget for the POAM item (stored as a property).
     * @summary Create POAM from finding
     * @param {POAMCreateRequest} pOAMCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    createPOAMFromFindingRaw(requestParameters: CreatePOAMFromFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMDto>>;

    /**
     * Creates a new Plan of Action and Milestones (POAM) linked to a finding. The POAM will contain a POAM item that references the finding. Optional budget for the POAM item (stored as a property).
     * Create POAM from finding
     */
    createPOAMFromFinding(requestParameters: CreatePOAMFromFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMDto>;

    /**
     * Deletes a milestone from a POAM item.
     * @summary Delete milestone
     * @param {string} poamId POAM UUID
     * @param {string} itemId POAM item UUID
     * @param {string} milestoneId Milestone UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    deleteMilestoneRaw(requestParameters: DeleteMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a milestone from a POAM item.
     * Delete milestone
     */
    deleteMilestone(requestParameters: DeleteMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Returns the list of all milestones for the given POAM item (ordered by sequence, then due date).
     * @summary Get milestones for POAM item
     * @param {string} poamId POAM UUID
     * @param {string} itemId POAM item UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    getMilestonesForItemRaw(requestParameters: GetMilestonesForItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MilestoneDto>>>;

    /**
     * Returns the list of all milestones for the given POAM item (ordered by sequence, then due date).
     * Get milestones for POAM item
     */
    getMilestonesForItem(requestParameters: GetMilestonesForItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MilestoneDto>>;

    /**
     * Retrieves a specific POAM by its UUID with all associated POAM items.
     * @summary Get POAM by ID
     * @param {string} poamId POAM UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    getPOAMByIdRaw(requestParameters: GetPOAMByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMDto>>;

    /**
     * Retrieves a specific POAM by its UUID with all associated POAM items.
     * Get POAM by ID
     */
    getPOAMById(requestParameters: GetPOAMByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMDto>;

    /**
     * Retrieves a paginated list of POAMs, optionally filtered by status (open, closed, in-progress).
     * @summary List POAMs
     * @param {string} [status] Status filter (open, closed, in-progress)
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    getPOAMsRaw(requestParameters: GetPOAMsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMListResponse>>;

    /**
     * Retrieves a paginated list of POAMs, optionally filtered by status (open, closed, in-progress).
     * List POAMs
     */
    getPOAMs(requestParameters: GetPOAMsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMListResponse>;

    /**
     * Updates an existing milestone on a POAM item. Only provided fields are updated.
     * @summary Update milestone
     * @param {string} poamId POAM UUID
     * @param {string} itemId POAM item UUID
     * @param {string} milestoneId Milestone UUID
     * @param {MilestoneUpdateRequest} milestoneUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    updateMilestoneRaw(requestParameters: UpdateMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MilestoneDto>>;

    /**
     * Updates an existing milestone on a POAM item. Only provided fields are updated.
     * Update milestone
     */
    updateMilestone(requestParameters: UpdateMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MilestoneDto>;

    /**
     * Updates an existing POAM and its associated POAM items. Only provided fields will be updated. Optional budget for the POAM item (stored as a property).
     * @summary Update POAM
     * @param {string} poamId POAM UUID
     * @param {POAMUpdateRequest} pOAMUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    updatePOAMRaw(requestParameters: UpdatePOAMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMDto>>;

    /**
     * Updates an existing POAM and its associated POAM items. Only provided fields will be updated. Optional budget for the POAM item (stored as a property).
     * Update POAM
     */
    updatePOAM(requestParameters: UpdatePOAMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMDto>;

    /**
     * Updates an existing POAM item (project item). Only provided fields are updated.
     * @summary Update POAM item
     * @param {string} poamId POAM UUID
     * @param {string} itemId POAM item UUID
     * @param {POAMItemUpdateRequest} pOAMItemUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof POAMApiInterface
     */
    updatePOAMItemRaw(requestParameters: UpdatePOAMItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMItemDto>>;

    /**
     * Updates an existing POAM item (project item). Only provided fields are updated.
     * Update POAM item
     */
    updatePOAMItem(requestParameters: UpdatePOAMItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMItemDto>;

}

/**
 * 
 */
export class POAMApi extends runtime.BaseAPI implements POAMApiInterface {

    /**
     * Creates a new milestone for the given POAM item. Title is required.
     * Add milestone to POAM item
     */
    async addMilestoneRaw(requestParameters: AddMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MilestoneDto>> {
        if (requestParameters['poamId'] == null) {
            throw new runtime.RequiredError(
                'poamId',
                'Required parameter "poamId" was null or undefined when calling addMilestone().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling addMilestone().'
            );
        }

        if (requestParameters['milestoneCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'milestoneCreateRequest',
                'Required parameter "milestoneCreateRequest" was null or undefined when calling addMilestone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/poam/{poamId}/items/{itemId}/milestones`;
        urlPath = urlPath.replace(`{${"poamId"}}`, encodeURIComponent(String(requestParameters['poamId'])));
        urlPath = urlPath.replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MilestoneCreateRequestToJSON(requestParameters['milestoneCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MilestoneDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new milestone for the given POAM item. Title is required.
     * Add milestone to POAM item
     */
    async addMilestone(requestParameters: AddMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MilestoneDto> {
        const response = await this.addMilestoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new POAM item (project item) to an existing POAM. Title and description are required. Optional findingId links the item to a finding and control.
     * Add POAM item
     */
    async addPOAMItemRaw(requestParameters: AddPOAMItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMItemDto>> {
        if (requestParameters['poamId'] == null) {
            throw new runtime.RequiredError(
                'poamId',
                'Required parameter "poamId" was null or undefined when calling addPOAMItem().'
            );
        }

        if (requestParameters['pOAMItemCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'pOAMItemCreateRequest',
                'Required parameter "pOAMItemCreateRequest" was null or undefined when calling addPOAMItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/poam/{poamId}/items`;
        urlPath = urlPath.replace(`{${"poamId"}}`, encodeURIComponent(String(requestParameters['poamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: POAMItemCreateRequestToJSON(requestParameters['pOAMItemCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => POAMItemDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new POAM item (project item) to an existing POAM. Title and description are required. Optional findingId links the item to a finding and control.
     * Add POAM item
     */
    async addPOAMItem(requestParameters: AddPOAMItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMItemDto> {
        const response = await this.addPOAMItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new Plan of Action and Milestones (POAM) linked to a finding. The POAM will contain a POAM item that references the finding. Optional budget for the POAM item (stored as a property).
     * Create POAM from finding
     */
    async createPOAMFromFindingRaw(requestParameters: CreatePOAMFromFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMDto>> {
        if (requestParameters['pOAMCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'pOAMCreateRequest',
                'Required parameter "pOAMCreateRequest" was null or undefined when calling createPOAMFromFinding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/poam`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: POAMCreateRequestToJSON(requestParameters['pOAMCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => POAMDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new Plan of Action and Milestones (POAM) linked to a finding. The POAM will contain a POAM item that references the finding. Optional budget for the POAM item (stored as a property).
     * Create POAM from finding
     */
    async createPOAMFromFinding(requestParameters: CreatePOAMFromFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMDto> {
        const response = await this.createPOAMFromFindingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a milestone from a POAM item.
     * Delete milestone
     */
    async deleteMilestoneRaw(requestParameters: DeleteMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['poamId'] == null) {
            throw new runtime.RequiredError(
                'poamId',
                'Required parameter "poamId" was null or undefined when calling deleteMilestone().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling deleteMilestone().'
            );
        }

        if (requestParameters['milestoneId'] == null) {
            throw new runtime.RequiredError(
                'milestoneId',
                'Required parameter "milestoneId" was null or undefined when calling deleteMilestone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/poam/{poamId}/items/{itemId}/milestones/{milestoneId}`;
        urlPath = urlPath.replace(`{${"poamId"}}`, encodeURIComponent(String(requestParameters['poamId'])));
        urlPath = urlPath.replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId'])));
        urlPath = urlPath.replace(`{${"milestoneId"}}`, encodeURIComponent(String(requestParameters['milestoneId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a milestone from a POAM item.
     * Delete milestone
     */
    async deleteMilestone(requestParameters: DeleteMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMilestoneRaw(requestParameters, initOverrides);
    }

    /**
     * Returns the list of all milestones for the given POAM item (ordered by sequence, then due date).
     * Get milestones for POAM item
     */
    async getMilestonesForItemRaw(requestParameters: GetMilestonesForItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MilestoneDto>>> {
        if (requestParameters['poamId'] == null) {
            throw new runtime.RequiredError(
                'poamId',
                'Required parameter "poamId" was null or undefined when calling getMilestonesForItem().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling getMilestonesForItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/poam/{poamId}/items/{itemId}/milestones`;
        urlPath = urlPath.replace(`{${"poamId"}}`, encodeURIComponent(String(requestParameters['poamId'])));
        urlPath = urlPath.replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MilestoneDtoFromJSON));
    }

    /**
     * Returns the list of all milestones for the given POAM item (ordered by sequence, then due date).
     * Get milestones for POAM item
     */
    async getMilestonesForItem(requestParameters: GetMilestonesForItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MilestoneDto>> {
        const response = await this.getMilestonesForItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific POAM by its UUID with all associated POAM items.
     * Get POAM by ID
     */
    async getPOAMByIdRaw(requestParameters: GetPOAMByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMDto>> {
        if (requestParameters['poamId'] == null) {
            throw new runtime.RequiredError(
                'poamId',
                'Required parameter "poamId" was null or undefined when calling getPOAMById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/poam/{poamId}`;
        urlPath = urlPath.replace(`{${"poamId"}}`, encodeURIComponent(String(requestParameters['poamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => POAMDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific POAM by its UUID with all associated POAM items.
     * Get POAM by ID
     */
    async getPOAMById(requestParameters: GetPOAMByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMDto> {
        const response = await this.getPOAMByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of POAMs, optionally filtered by status (open, closed, in-progress).
     * List POAMs
     */
    async getPOAMsRaw(requestParameters: GetPOAMsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/poam`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => POAMListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of POAMs, optionally filtered by status (open, closed, in-progress).
     * List POAMs
     */
    async getPOAMs(requestParameters: GetPOAMsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMListResponse> {
        const response = await this.getPOAMsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing milestone on a POAM item. Only provided fields are updated.
     * Update milestone
     */
    async updateMilestoneRaw(requestParameters: UpdateMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MilestoneDto>> {
        if (requestParameters['poamId'] == null) {
            throw new runtime.RequiredError(
                'poamId',
                'Required parameter "poamId" was null or undefined when calling updateMilestone().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling updateMilestone().'
            );
        }

        if (requestParameters['milestoneId'] == null) {
            throw new runtime.RequiredError(
                'milestoneId',
                'Required parameter "milestoneId" was null or undefined when calling updateMilestone().'
            );
        }

        if (requestParameters['milestoneUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'milestoneUpdateRequest',
                'Required parameter "milestoneUpdateRequest" was null or undefined when calling updateMilestone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/poam/{poamId}/items/{itemId}/milestones/{milestoneId}`;
        urlPath = urlPath.replace(`{${"poamId"}}`, encodeURIComponent(String(requestParameters['poamId'])));
        urlPath = urlPath.replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId'])));
        urlPath = urlPath.replace(`{${"milestoneId"}}`, encodeURIComponent(String(requestParameters['milestoneId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MilestoneUpdateRequestToJSON(requestParameters['milestoneUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MilestoneDtoFromJSON(jsonValue));
    }

    /**
     * Updates an existing milestone on a POAM item. Only provided fields are updated.
     * Update milestone
     */
    async updateMilestone(requestParameters: UpdateMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MilestoneDto> {
        const response = await this.updateMilestoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing POAM and its associated POAM items. Only provided fields will be updated. Optional budget for the POAM item (stored as a property).
     * Update POAM
     */
    async updatePOAMRaw(requestParameters: UpdatePOAMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMDto>> {
        if (requestParameters['poamId'] == null) {
            throw new runtime.RequiredError(
                'poamId',
                'Required parameter "poamId" was null or undefined when calling updatePOAM().'
            );
        }

        if (requestParameters['pOAMUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'pOAMUpdateRequest',
                'Required parameter "pOAMUpdateRequest" was null or undefined when calling updatePOAM().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/poam/{poamId}`;
        urlPath = urlPath.replace(`{${"poamId"}}`, encodeURIComponent(String(requestParameters['poamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: POAMUpdateRequestToJSON(requestParameters['pOAMUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => POAMDtoFromJSON(jsonValue));
    }

    /**
     * Updates an existing POAM and its associated POAM items. Only provided fields will be updated. Optional budget for the POAM item (stored as a property).
     * Update POAM
     */
    async updatePOAM(requestParameters: UpdatePOAMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMDto> {
        const response = await this.updatePOAMRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing POAM item (project item). Only provided fields are updated.
     * Update POAM item
     */
    async updatePOAMItemRaw(requestParameters: UpdatePOAMItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<POAMItemDto>> {
        if (requestParameters['poamId'] == null) {
            throw new runtime.RequiredError(
                'poamId',
                'Required parameter "poamId" was null or undefined when calling updatePOAMItem().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling updatePOAMItem().'
            );
        }

        if (requestParameters['pOAMItemUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'pOAMItemUpdateRequest',
                'Required parameter "pOAMItemUpdateRequest" was null or undefined when calling updatePOAMItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/poam/{poamId}/items/{itemId}`;
        urlPath = urlPath.replace(`{${"poamId"}}`, encodeURIComponent(String(requestParameters['poamId'])));
        urlPath = urlPath.replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: POAMItemUpdateRequestToJSON(requestParameters['pOAMItemUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => POAMItemDtoFromJSON(jsonValue));
    }

    /**
     * Updates an existing POAM item (project item). Only provided fields are updated.
     * Update POAM item
     */
    async updatePOAMItem(requestParameters: UpdatePOAMItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<POAMItemDto> {
        const response = await this.updatePOAMItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
